import { createSelector } from 'reselect';
import { IReduxState } from '../../redux/redux.interface';

const getChildrenState = (state: IReduxState) => state.children;

export const getChildrenReduxState = createSelector(
  [getChildrenState],
  (state) => state
);
